import { Typography } from "@mui/material";
import React, { useMemo } from "react";

const InfoItemLabel = ({
  children,
  fontSize,
  color = "#64748b",
  sx,
  variant = "caption",
  textTransform = "uppercase",
}) => {
  const styles = useMemo(() => {
    return {
      fontSize: fontSize,
      color,
      textTransform: textTransform,
      letterSpacing: "0.5px",
      fontWeight: 400,
      ...sx,
    };
  }, [sx, fontSize, color, textTransform]);
  return (
    <Typography variant={variant} sx={styles}>
      {children}
    </Typography>
  );
};

export default InfoItemLabel;
